import { instantsInterceptor, } from '@/api/index';

function passwordCheck(password) {
    return instantsInterceptor.post('/service/mylibrary/myinfo/detail', { password: password });
}

function updateUser(user) {
    return instantsInterceptor.post('/service/mylibrary/myinfo/update', user);
}

export { passwordCheck, updateUser };